<template src='./GestionOrdenes.html'></template>
<script>
import { consultarEstructuraCuestionarioPorId } from "../../apiService/request/CrudSeguimiento";
import { consultarOrdenesPaciente } from "../../apiService/request/CrudOrdenes";
import TarjetasNuevasMomento from "../TarjetasNuevasMomento/TrajetasNuevasMomento";
import Carrusel from "../Carrusel/Carrusel";
import SubirArchivo from "../SubirArchivo/SubirArchivo";

export default {
  data() {
    return {
      arrayOrdenes: [],
      paciente: {}
    };
  },
  created() {
    if (this.$store.getters.getIdFormulario){
      this.consultarEstructuraOrdenes();
    }
    this.consultarTotalOrdenesPaciente();
    this.paciente = {
      documento: this.$store.getters.getCedulaPaciente,
      nombre: this.$store.getters.getNombrePaciente
    };
  },
  props: {
    banderaCargarArchivo: {
      type: Boolean,
      default: true
    }
  },
  components: {
    TarjetasNuevasMomento,
    Carrusel,
    SubirArchivo
  },
  methods: {
    async consultarEstructuraOrdenes() {
      try {
        const respuesta = await consultarEstructuraCuestionarioPorId(
          this.$store.getters.getIdFormulario,
          "ordenes",
          "ordenes"
        );
        if(respuesta && respuesta.data && respuesta.data) {
          this.$store.dispatch(
            "setVariablesFormularios",
            respuesta.data.data.variables
          );
          this.$store.dispatch("setNombreFormulario", respuesta.data.data.key);
          this.$store.dispatch("setColeccion", respuesta.data.data.coleccion);
        }
      } finally {
      }
    },
    async consultarTotalOrdenesPaciente() {
      const respuesta = await consultarOrdenesPaciente(
        this.$store.getters.getCedulaPaciente
      );
      if (respuesta.data && respuesta.data.data && respuesta.data.data.data) {
        this.arrayOrdenes = respuesta.data.data.data;
      }
    },
    cerrarAbrirOverlay() {
      this.$emit("formularioActualizado");
    }
  }
};
</script>
<style lang="scss" scoped src='./GestionOrdenes.scss'>
</style>


// WEBPACK FOOTER //
// src/components/GestionOrdenes/GestionOrdenes.vue